import React, { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
//
//MUI Components
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";

export default function Users() {
	const [rows, setRows] = useState([]);
	const [selectionModel, setSelectionModel] = useState([]);
	const [sortModel, setSortModel] = useState([{ field: "name", sort: "asc" }]);

	useEffect(() => {
		const fetchRows = async () => {
			const res = await fetch(`${process.env.REACT_APP_API_URL}/users`, {
				credentials: "include",
			});
			const data = await res.json();
			return data;
		};

		const getRows = async () => {
			let rowsFromServer = await fetchRows();
			rowsFromServer = rowsFromServer.data.map((row) => {
				return {
					...row,
					createdAt: dayjs(row.createdAt).format("MM-DD-YY hh:mm:ss A"),
				};
			});
			setRows(rowsFromServer);
		};

		getRows();
	}, []);

	const deleteFromAPI = async (id) => {
		try {
			await fetch(`${process.env.REACT_APP_API_URL}/users/${id}`, {
				method: "DELETE",
				credentials: "include",
			});
		} catch (e) {
			console.log(e);
		}
	};

	const onClickDeleteAll = async () => {
		selectionModel.forEach((id) => {
			deleteFromAPI(id);
		});

		//Remove selectionModeled items from the rows state
		let newRows = [...rows];
		for (let i = 0; i < selectionModel.length; i++) {
			newRows = newRows.filter((row) => row._id !== selectionModel[i]);
		}
		await setRows(newRows);

		//Clear selection
		setSelectionModel([]);
	};

	const columns = useMemo(
		() => [
			{ field: "_id", headerName: "ID", hide: true, width: 225 },
			{
				field: "name",
				headerName: "Name",
				renderCell: (params) => (
					<React.Fragment>
						<IconButton
							component={Link}
							to={`/${process.env.REACT_APP_ADMIN_URL}/users/${params.row._id}`}
							style={{ marginRight: ".5rem" }}
							aria-label="edit"
						>
							<EditIcon />
						</IconButton>
						{params.value}
					</React.Fragment>
				),
				width: 300,
			},
			{
				field: "email",
				headerName: "E-mail",
				width: 300,
			},
			{
				field: "role",
				headerName: "Role",
				width: 130,
			},
			{
				field: "active",
				headerName: "Active",
				width: 130,
			},
			{
				field: "createdAt",
				headerName: "Created At",
				width: 175,
			},
		],
		[]
	);

	const useStyles = makeStyles({
		datagrid: {
			backgroundColor: "white",
			//Remove outlines when clicking a cell in the datagrid
			"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
				outline: 0,
			},
			//Remove outlines when clicking a column header
			"&.MuiDataGrid-root .MuiDataGrid-colCell:focus": {
				outline: 0,
			},
		},
	});

	const classes = useStyles();

	return (
		<>
			<div
				style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}
			>
				<Typography component="h1" variant="h4">
					Users
				</Typography>
				<Button
					startIcon={<AddIcon />}
					style={{ marginLeft: "1rem" }}
					color="primary"
					variant="contained"
					component={Link}
					to={`/${process.env.REACT_APP_ADMIN_URL}/users/add`}
				>
					Add New
				</Button>
				{selectionModel.length > 0 && (
					<Button
						startIcon={<DeleteIcon />}
						style={{ marginLeft: "1rem" }}
						color="secondary"
						variant="contained"
						onClick={onClickDeleteAll}
					>
						Delete
					</Button>
				)}
			</div>
			<DataGrid
				className={classes.datagrid}
				components={{
					Toolbar: GridToolbar,
				}}
				getRowId={(row) => row._id}
				autoHeight
				rows={rows}
				columns={columns}
				checkboxSelection
				sortModel={sortModel}
				onSortModelChange={(model) => setSortModel(model)}
				selectionModel={selectionModel}
				onSelectionModelChange={(newSelection) => {
					setSelectionModel(newSelection);
				}}
			/>
		</>
	);
}
